module.exports = __webpack_public_path__ + "img/bg_classify2.4a0e51a9.png";